import React, { useState } from 'react';
import {} from 'reactstrap';
import PageBreadcrumb from '../../../Components/Common/PageBreadcrumb';
import ProductHydro from './ProductHydro';
import useTenderOpeningInsights from '../hooks/useTenderOpeningInsights';
import { TENDER_QUICK_FILTERS } from '../utils/tenderOpeningListExport';
import { HeroInsights } from '../../Procurement/component/ListBadges';
import './TenderOpening.css';

// This page lists Product Hydro procurements only (ProcurementTypeHeader = 1).
const PROCUREMENT_TYPE_HEADER = '1';

const TenderOpening = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [quickFilter, setQuickFilter] = useState('');

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  const insights = useTenderOpeningInsights({
    procurementTypeHeader: PROCUREMENT_TYPE_HEADER,
    refreshTrigger,
  });

  return (
    <React.Fragment>
      <div className='to-page email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4'>
            <div className='to-hero mb-4'>
              <PageBreadcrumb
                fallback={{
                  label: 'Tender Opening',
                  to: '/apps-tenderopening/view',
                }}
              />

              <div className='d-flex align-items-center gap-3 flex-wrap'>
                <span className='to-hero-icon'>
                  <i className='ri-auction-line' aria-hidden='true' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='to-hero-title'>Tender Opening</h4>
                  <p className='to-hero-subtitle'>
                    Track every procurement from HPS request to supplier,
                    panitia and freight readiness.
                  </p>
                </div>
                <button
                  type='button'
                  className='to-hero-btn'
                  onClick={handleRefresh}
                >
                  <i className='ri-refresh-line' aria-hidden='true' />
                  Refresh
                </button>
              </div>

              <HeroInsights
                insights={insights}
                filters={TENDER_QUICK_FILTERS}
                activeKey={quickFilter}
                onChange={setQuickFilter}
                noun='tender'
                emptyLabel='No open tender near its deadline'
              />
            </div>

            <ProductHydro
              refreshTrigger={refreshTrigger}
              quickFilter={quickFilter}
              onQuickFilterChange={setQuickFilter}
              exportName='Product Hydro'
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(TenderOpening);
